exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nthead {\ntr th {\n        border: none;\n        font-weight: 600;\n        font-size: 18px !important;\n        padding-bottom: 1rem !important;\n        #text-align: right;\n}\n}\ntbody {\ntr td {\n        #text-align: right;\n}\n}\n", ""]);

// exports
